/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import { IShippingMapConfig } from './shipping-map.props.autogenerated';

// ==============================================================================
// Interfaces
// ==============================================================================
interface IShippingMapLegendProps {
    config: IShippingMapConfig | undefined;
}

// ==============================================================================
/**
 * ShippingMapLegend component
 * @extends {React.PureComponent<IShippingMapLegendProps>}
 */
// ==============================================================================
class ShippingMapLegend extends React.PureComponent<IShippingMapLegendProps> {

    // ------------------------------------------------------
    // ------------------------------------------------------
    public render(): JSX.Element {
        const { config } = this.props;

        return (
            <div className='shipping-map-legend'>
                {config && config.textRestrictShipping &&
                    <div className='shipping-map-legend-item shipping-map-legend-item-restricted'>
                        <div className='shipping-map-legend-item-box' />
                        <div className='shipping-map-legend-item-text'>{config.textRestrictShipping}</div>
                    </div>
                }
                {config && config.textAllowShipping &&
                    <div className='shipping-map-legend-item shipping-map-legend-item-allowed'>
                        <div className='shipping-map-legend-item-box shipping-map-legend-item-box-active' />
                        <div className='shipping-map-legend-item-text'>{config.textAllowShipping}</div>
                    </div>
                }
            </div>
        );
    }
}

export default ShippingMapLegend;